
<script setup>
import { usePage } from "@inertiajs/inertia-vue3";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, watch } from "vue";

const page_name = "Integration";

const props = defineProps({
  oteo_api_token: String,
  anysms_id: String,
  anysms_token: String,
  errors: Object,
});

const form = useForm({
  anysms_id: props.anysms_id,
  anysms_token: props.anysms_token,
});

function submitForm() {
  form.put("/integration");
}
</script>


<template>
  <SettingsLayout>
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink class="mr-3" href="/" type="close">Schließen</HeaderLink>
      <HeaderButton @click="submitForm()">Speichern</HeaderButton>
    </template>
    <div class="max-w-2xl">
      <Heading title="Oteo API Schlüssel" />

      <p class="text-sm text-oteoText">
        API Schlüssel für den Import von Patientendaten aus dios & co.
      </p>
      <Label class="mt-4">Oteo API Schlüssel</Label>

      <Input
        class="w-96 opacity-70"
        :value="props.oteo_api_token"
        disabled
        type="text"
      />

      <Heading class="mt-8" title="SMS Versandeinstellungen" />

      <p class="text-sm text-oteoText">
        Geben Sie hier Ihre Any-sms Daten an um Terminbestätigungen sowie
        Erinnerungen via SMS zu versenden. Bitte beachten Sie, dass Sie beim
        Absendernamen nur 11 Zeichen verwenden können.
      </p>
      <Label class="mt-4">Any-sms Nutzer-ID</Label>

      <Input class="w-96" v-model="form.anysms_id" type="text" />
      <div class="mt-2 text-red-600 text-sm" v-if="errors.anysms_id">
        {{ errors.anysms_id }}
      </div>
      <Label class="mt-4">Any-sms API Schlüssel</Label>

      <Input class="w-96" v-model="form.anysms_token" type="text" />
      <div class="mt-2 text-red-600 text-sm" v-if="errors.anysms_token">
        {{ errors.anysms_token }}
      </div>

      <Heading class="mt-8" title="Terminimport" />

      <p class="text-sm text-oteoText">
        Nutzen Sie den Terminimporter um ihre bestehenden Termine aus Ihren
        Altsystemen zu übernehmen.
        <a class="text-oteo-300" href="/einstellungen/termin-importer"
          >Hier klicken</a
        >.
      </p>
    </div>
  </SettingsLayout>
</template>
